export const PRODUCT_TYPES = [
  // "Glow Sign Boards",
  // "Glow Sign Boards (Both Side)",
  // "Non Lit Board",
  // "Non Lit Board (Both Side)",
  // "3D letters",
  // "UV Print",
  // "Flex",
  // "Vinyl",
  // "Backlit",
  // "ACP",
  // "Canvas",
  // "ACP Canopy for Board (Pelmet)",
  // "ACP Cladding",
  // "ACP LIT BOARD WITH ACRYLIC LETTER",
  // "ACP NON-LIT BOARD WITH ACRYLIC LETTER",
  // "Custom Flange (lite)",
  // "Vinyl Pasting",
  // "One Way Vision",
  // "ACP Wall signage",
  // "SHUTTER PAINTING",
  // "WALL PAINTING",
  // "Standard ACP Board",
  // "Sandwich (Acrylic)",
  // "FSU (Sunpack)/ BubbleGuard",
  // "Standee",
  // "Custom Cut-Out Standee",
  // "Rollup standee",
  // "Backdrop standee",
  // "Arch gate",
  // "POSM",
  // "Round Lollipop",
  // "Square Lollipop",
  // "Poster (A3/A4/A5/A6)",
  // "Foldable Rack iron",
  // "Road signage",
  // "Totem",
  // "Tent Card",
  // "Gazebo",
  // "Promotable",
  // "Canopy",
  // "Clip on (lit/ non-lt)",
  // "Sequence signage",
  // "Blockout signage",
  // "In Shop Branding",
  // "Van Branding",
  // "Dropdown Flag",
  // "Emergency Signage",
  // "LED Display Signage",
  // "CUT (Table Top)",
  // "Podium",
  // "Name Plate",
  // "Digital Signage",
  // "Street Light Pole Branding",
  "Flex Frame Signage",
  "ACP Non Lit Signage",
  "ACP Backlit Signage",
  "Glow Sign Board",
  "Non Lit Flange Signage",
  "Backlit Flange Signage",
  "ACP Cladding",
  "ACP Canopy",
  "3D Channel Letters",
  "Electrical Fittings",
  "Non Lit  Flex Arch Gate",
  "Backlit Flex Arch Gate",
  "LED Screen P4.0",
  "LED Screen P6.0",
  "Vinyl Branding",
  "ACP Vinyl Branding",
  "Sunboard Vinyl Branding",
  "Toughened Glass Vinyl Branding",
  "One Way Vision Branding",
  "Danglers",
  "Posters",
  "Metal Display Stands / Racks",
  "Corrugated Display Stands",
  "Countertop Displays",
  "Parasite Displays",
  "Foldable Display Stands",
  "Roll Up Floor Standee ( Small )",
  "Roll Up Floor Standee ( Big )",
  "Cut Out Displays",
  "Custom Display",
  `Digital Display 24" Signage`,
  `Digital Display 32" Signage`,
  `FSU 40" Signage`,
  `FSU 55" Signage`,
  `FSU 65" Signage`,
  "Custom Display",
  "Wall Painting",
  "Shutter Painting",
  "Repairs",
  "Scaffolding",
];
